import { Button, Divider } from 'antd';

export const AssessmentFormActions = ({ isSubmitting, isEditMode, onToggleEdit, onCancel }) => {
    return (
        <>
            <Divider />
            <div className="d-flex justify-content-end gap-3 mt-4 mb-2">
                {!isEditMode ? (
                    <Button
                        type="primary"
                        size="large"
                        onClick={onToggleEdit}
                        style={{
                            borderRadius: '8px',
                            minWidth: '150px',
                            background: '#00d084',
                            border: 'none',
                            fontWeight: '600'
                        }}
                    >
                        Edit Assessment
                    </Button>
                ) : (
                    <>
                        <Button
                            type="default"
                            size="large"
                            onClick={onToggleEdit}
                            style={{ borderRadius: '8px', minWidth: '120px' }}
                        >
                            Cancel Edit
                        </Button>
                        <Button
                            type="primary"
                            size="large"
                            htmlType="submit"
                            loading={isSubmitting}
                            style={{
                                borderRadius: '8px',
                                minWidth: '180px',
                                background: 'linear-gradient(135deg, #1890ff 0%, #096dd9 100%)',
                                border: 'none',
                                boxShadow: '0 4px 12px rgba(24, 144, 255, 0.35)'
                            }}
                        >
                            Save Assessment
                        </Button>
                    </>
                )}
            </div>
        </>
    );
};
